import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BrainIcon, ActivityIcon } from 'lucide-react';
const LoadingScreen = () => {
  const navigate = useNavigate();
  const [progressPercent, setProgressPercent] = useState(0);
  const [statusText, setStatusText] = useState('Förbereder analys...');
  useEffect(() => {
    // Simulate analysis with multiple steps
    const statusMessages = ['Förbereder analys...', 'Analyserar dina svar...', 'Jämför med forskningsdata...', 'Identifierar minnesmönster...', 'Sammanställer personlig rapport...', 'Färdigställer resultat...'];
    // Total loading time: 5 seconds
    const totalTime = 5000;
    const interval = totalTime / 100;
    // Update progress bar
    const progressTimer = setInterval(() => {
      setProgressPercent(prev => {
        if (prev >= 100) {
          clearInterval(progressTimer);
          return 100;
        }
        return prev + 1;
      });
    }, interval);
    // Update status messages
    statusMessages.forEach((message, index) => {
      setTimeout(() => {
        setStatusText(message);
      }, totalTime / statusMessages.length * index);
    });
    // Redirect to results page after loading completes
    const redirectTimer = setTimeout(() => {
      navigate('/results');
    }, totalTime + 500);
    return () => {
      clearInterval(progressTimer);
      clearTimeout(redirectTimer);
    };
  }, [navigate]);
  return <div className="container mx-auto px-4 py-8 md:py-16" data-id="element-60">
      <div className="max-w-lg mx-auto bg-white rounded-lg shadow-lg p-8 text-center" data-id="element-61">
        <div className="flex justify-center mb-8" data-id="element-62">
          <div className="relative" data-id="element-63">
            <BrainIcon className="h-20 w-20 text-blue-600" data-id="element-64" />
            <div className="absolute -top-2 -right-2 animate-ping" data-id="element-65">
              <ActivityIcon className="h-6 w-6 text-blue-500" data-id="element-66" />
            </div>
          </div>
        </div>
        <h2 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-67">
          Analyserar dina svar
        </h2>
        <p className="text-gray-600 mb-8" data-id="element-68">
          Vår AI bearbetar dina svar och skapar en personlig minnesanalys
          baserad på de senaste neuropsykologiska forskningsrönen.
        </p>
        <div className="mb-8" data-id="element-69">
          <div className="flex justify-between items-center mb-2" data-id="element-70">
            <span className="text-sm font-medium text-gray-500" data-id="element-71">
              Analys pågår
            </span>
            <span className="text-sm font-medium text-blue-600" data-id="element-72">
              {progressPercent}%
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-3" data-id="element-73">
            <div className="bg-blue-600 h-3 rounded-full transition-all duration-300" style={{
            width: `${progressPercent}%`
          }} data-id="element-74"></div>
          </div>
          <div className="mt-3 text-sm text-blue-700 font-medium" data-id="element-75">
            {statusText}
          </div>
        </div>
        <div className="text-sm text-gray-500" data-id="element-76">
          <p data-id="element-77">Detta tar bara ett ögonblick. Vänligen stäng inte webbläsaren.</p>
        </div>
      </div>
    </div>;
};
export default LoadingScreen;